import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/fetch-duck";
import { IOrderFOB } from "interfaces/order-fob";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "FETCH_ORDER_FOB_" }
);

export interface FetchOrderFOBState extends IState {
  data: IOrderFOB | null;
}

export interface FetchOrderFOBSuccess extends ISuccessAction {
  data: IOrderFOB;
}

const INITIAL_STATE: FetchOrderFOBState = {
  data: null,
  loading: false,
  error: null,
};

const request = (state: FetchOrderFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: FetchOrderFOBState, action: FetchOrderFOBSuccess) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: FetchOrderFOBState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const fetchOrderFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchOrderFOBTypes = Types;
export const FetchOrderFOBActions = Creators;
